import { render, staticRenderFns } from "./document-title.vue?vue&type=template&id=f71ff066&scoped=true&lang=pug&"
import script from "./document-title.vue?vue&type=script&lang=ts&"
export * from "./document-title.vue?vue&type=script&lang=ts&"
import style0 from "./document-title.vue?vue&type=style&index=0&id=f71ff066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71ff066",
  null
  
)

export default component.exports